export default __webpack_public_path__ + "static/media/Gemeine-Ziege.d1fa2a8d.png";